
const { YOUNGTHON_API_ENDPOINT, MAPBOX_TOKEN } = process.env;

export const endpoint = YOUNGTHON_API_ENDPOINT;
export const mapbox = {
  token: MAPBOX_TOKEN || '',
  defaultCoordinate: [100.4960495, 13.7475282],
};